
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"61","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".3"}},[_c('path',{attrs:{"d":"M38.972 11.437V.847l9.884 10.59h-9.884z","fill":"#CCC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.429 1.166A3.671 3.671 0 0037.745 0H3.671A3.671 3.671 0 000 3.671v49.422a3.671 3.671 0 003.671 3.67H16.38a.847.847 0 100-1.694H3.67a1.977 1.977 0 01-1.977-1.976V3.67c0-1.091.886-1.977 1.977-1.977h34.074c.548 0 1.071.228 1.445.628l8.288 8.88c.341.366.531.848.531 1.349v40.542a1.977 1.977 0 01-1.977 1.976H30.5a.847.847 0 100 1.695h15.532a3.671 3.671 0 003.672-3.671V12.55a3.67 3.67 0 00-.988-2.505l-8.287-8.88z","fill":"#212C31"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.972 10.732V1.553H37.56v9.178c0 1.17.948 2.119 2.118 2.119h8.473v-1.412h-8.473a.706.706 0 01-.706-.707zM23.44 29.653c.468 0 .847.38.847.847v29.653a.847.847 0 11-1.694 0V30.5c0-.468.379-.847.847-.847z","fill":"#212C31"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.44 31.698l7.873 7.873a.847.847 0 101.198-1.198L24.538 30.4a1.553 1.553 0 00-2.197 0l-7.973 7.973a.847.847 0 101.199 1.198l7.873-7.873z","fill":"#212C31"}})])])
          )
        }
      }
    